import Loader from "../../atoms/Loader";

const FullScreenLoader = () => {
    return <div className="fullscreen-loader">
        <Loader />
    </div>
};

export default FullScreenLoader;
